import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'onlineReviewsLanguageFilter',
    standalone: false
})
export class OnlineReviewsLanguageFilterPipe implements PipeTransform {

  transform(reviews, filters) {
    let filteredReviews = [...reviews];
    if ( filteredReviews && filteredReviews.length > 0 ) {
      const filter = filters.find(filter => filter.name === 'language')
      const filtering = filter.options.some(option => option.isFiltering);
      if(filter && filtering) {
        const options = filter.options.filter(option => option.isFiltering).map(option => option.value);
        filteredReviews = filteredReviews.filter(item => {
          return options.includes(item.guest.language.id);
        })
      }
    }
    return filteredReviews;
  }

}
